import React, {Component} from "react";
/*
    Importing React Router library for routing of each page
*/
import { Link } from "react-router-dom";
/*
    For Redux, need to import connect and action
    Redux connect is to access Redux
    Redux action to update the state of the form field
*/
import { connect } from "react-redux";
/*
    This page is using a template with no progressbar and no nav
*/
import WelcomeLayout from '../../../containers/WelcomeLayout.js';

/*
    Reject view that displays the Reject page
    Remember JSX requires you to use camelcasing of attributes
    (ie className vs 'class', htmlFor vs 'for', tabIndex vs tab-index)
    Remember JSX requires all tags be closed (ie: self closed <hr />, <br />)
    Create React App requires alt tags for all <img> elements (good for SEO too)
    SVGs need to have the xml attributes removed
*/
class Reject extends Component {
  render() {
      //TODO - change to sponsored listing links
      const nextLink = "/";

      return (
        <WelcomeLayout>
          <div className="container">
            <div className="text-center topcopy">
              <h1 className="padtop30">Unfortunately, we&#39;re unable to approve your application at this time.</h1>
              <h5 className="padtop">However, you may be able to find a loan product suitable for you from sponsored listings*.</h5>
              <Link className="btn next-step padtop30" tabIndex="1" to={nextLink}><span>Continue</span></Link>
              <p className="padtop30">
                Please note that by clicking "continue", you are navigating away from the MoneyKey website to the website of an unaffiliated third party.
              </p>
              <p className="padtop">
                *MoneyKey does not promote or endorse the sponsored listings, and does not assume responsibility or liability for any actions taken by you in relation to any such sponsored listings.
              </p>
              <p className="padtop30"><a href="/">Take me back to MoneyKey</a></p>
            </div>
          </div>
        </WelcomeLayout>
        );
    }
}

const mapStateToProps = (state) => ({
    eml: state.FormReducer.eml,
    st: state.FormReducer.st,
    loanamt: state.FormReducer.loanamt,
})

export default connect(mapStateToProps)(Reject);



// WEBPACK FOOTER //
// ./src/components/views/Reject/index.js